import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import "./style.css"

function Slider({ images, setImages }) {
    const location = useLocation();
    const [counter, setCounter] = useState(0);
    const [className, setClassName] = useState('slider');

    useEffect(() => {
        if (location) {
            const path = location.pathname.split('/');
            if (path[1] && path[1] === 'article') setClassName('slider_cube');
        }
    }, [location]);

    const handleFile = (e, mod) => {
        const file = e.target.files[0];
        if (!file) return

        const url = URL.createObjectURL(file);

        e.target.value = '';

        let newImagesList = [...images];

        if (mod === 'add') newImagesList.push({ file, url });
        else newImagesList[counter] = { file, url };

        setImages(prev => {
            return {
                ...prev,
                images: newImagesList
            }
        });

        const newCounter = mod === 'add' ? newImagesList.length - 1 : counter;
        setCounter(newCounter);
    }

    const deleteFile = (idx) => {
        if (images.length <= 1) return

        const newSlider = images.filter((s, id) => id !== idx);

        if (counter !== 0) {
            setCounter(counter - 1);
        }

        setImages(prev => {
            return {
                ...prev,
                images: newSlider
            }
        })
    }

    const switchLeft = (idx) => {
        if (idx === 0) return;

        const newList = [...images];
        [newList[idx - 1], newList[idx]] = [newList[idx], newList[idx - 1]];
        
        setImages(prev => ({ 
            ...prev, 
            images: newList 
        }));
    };

    const switchRight = (idx) => {
        if (idx === images.length - 1) return;

        const newList = [...images];
        [newList[idx], newList[idx + 1]] = [newList[idx + 1], newList[idx]];
        
        setImages(prev => ({ 
            ...prev, 
            images: newList 
        }));
    };

    return (
        <div className={className}>
            <div className="view">
                {images[counter] && <i style={{ backgroundImage: `url(${images[counter].url})` }}></i>}
                <input type="file" onChange={(e) => handleFile(e)} />
                {!images[counter] && <span>Ajouter une image</span>}
            </div>

            <div className="panel_slider">
                {images.map((img, idx) => (

                    <div key={idx} className="slide">
                        {idx !== 0 &&
                            <button
                                className="del_slide btn_panel"
                                onClick={() => deleteFile(idx)}
                            ><i className="fas fa-xmark"></i></button>
                        }

                        {idx !== images.length - 1 &&
                            <button
                                className="btn_right btn_panel"
                                onClick={() => switchRight(idx)}
                            ><i className="fas fa-chevron-right"></i></button>
                        }

                        {idx !== 0 &&
                            <button
                                className="btn_left btn_panel"
                                onClick={() => switchLeft(idx)}
                            ><i className="fas fa-chevron-left"></i></button>
                        }

                        <button
                            className="btn_slide"
                            onClick={() => setCounter(idx)}
                            style={{ backgroundImage: `url(${img.url})` }}
                        ></button>
                    </div>
                ))}

                <button className="btn_add">
                    <i className="fas fa-plus"></i>
                    <input type="file" onChange={(e) => handleFile(e, 'add')} />
                </button>
            </div>
        </div >
    )
}

export default Slider;